var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('inputs',{attrs:{"title":_vm.title,"type":_vm.type,"show-fabric-rolls":true,"barcode":true,"show-fabric-selection-mode":true,"show-external-order-selector":true,"fabric-selection-mode-label":"Manual (Select if there is no underlying order or you want to select which fabric is cut manually)"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }